/* eslint react-hooks/exhaustive-deps: "warn" */

import { useContext } from 'react';

import { ContentContext } from 'context/ContentContext';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './LinkageHeroSection.module.scss';

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M3 8h10M9 4l4 4-4 4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LinkageHeroSection = () => {
  const { secondaryNavigation } = useContext(ContentContext);
  const { t } = useInt();

  return (
    <Section className={styles.root}>
      <div className={styles.inner}>
        <TitleBlock
          size="page"
          title={t('Uncover the full corporate tree. Instantly.')}
          description={
            <>
              {t('Map any entity to its')}{' '}
              <b>{t('immediate parent, domestic ultimate, and global ultimate')}</b>.
            </>
          }
        />

        <div className={styles.actions}>
          {secondaryNavigation?.book_demo?.slug && (
            <Button type="blue" size="xxl" route={secondaryNavigation.book_demo.slug} suffix={<ArrowIcon />}>
              {t('View full corporate structure')}
            </Button>
          )}

          {secondaryNavigation?.api_access?.slug && (
            <Button type="dark-outline" size="xxl" route={secondaryNavigation.api_access.slug}>
              {t('Start a match test')}
            </Button>
          )}
        </div>
      </div>
    </Section>
  );
};
